module.exports = __webpack_public_path__ + "img/close_new.e25414c9.svg";